"use strict";

exports.__esModule = true;
exports.default = void 0;
var _overArg = _interopRequireDefault(require("./_overArg.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Built-in value references. */
var getPrototype = (0, _overArg.default)(Object.getPrototypeOf, Object);
var _default = exports.default = getPrototype;